<template>
  <div class="modal fade bs-example-modal-lg" :id="modalId" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <img :src="imgSrc"  class="image-width-100" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Modal',
  components: {},
  props: {
    imgSrc: {
      type: String,
      default:'',
    },
    modalId: {
      type: String,
      default:'',
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {

  },
  mounted() {
  },
}
</script>
<style scoped>
.modal-dialog{
  top: 5%;
}
.modal-lg{
  --bs-modal-width: 75%;
}
</style>